<template>
   <nav class="navbar navbar-expand-md navbar-light fixed-top py-3" id="mainNav">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <img class="logo" src="/img/logos/Light-Logo.png" alt="">
        </router-link>
        <span class="navbar-toggler">
          <img class="menu" src="/img/mobile/menu.svg" alt="logo">
        </span>
        <div class="navbar-wrapper">
          <ul class="navbar-nav ml-auto my-2 my-lg-0">
            <li class="logo-wrap">
              <router-link class="nav-logo" to="/">
                <img src="/img/logos/Normal-Logo.png" alt="">
              </router-link>
              <a class="exit-menu" href="#">
                <img src="/img/mobile/close.svg" alt="">
              </a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/about">About Us</router-link>
            </li>
            <li class="nav-item">
               <a class="nav-link" href="http://blog.coralstone.capital">Blog</a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/careers">Careers</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/contact">Contact Us</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</template>

<script>

export default {
  mounted() {
    const top = document.querySelector('#mainNav');
    //const logo = document.querySelector('.logo');
    const menu = document.querySelector('.menu');
    const navbarWrapper = document.querySelector('.navbar-wrapper');
    const exitMenu = document.querySelector('.exit-menu');

    window.addEventListener('scroll', () => {
      if(window.scrollY > 50) {
        top.classList.add('navbar-scrolled')
        //logo.src = '/img/logos/Normal-Logo.png';
        //menu.src = '/img/mobile/menu-black.svg';
      } else {
        top.classList.remove('navbar-scrolled')
        //logo.src = '/img/logos/Light-Logo.png';
        //menu.src = '/img/mobile/menu.svg';

      }
    });

    menu.addEventListener('click', function() {
      //console.log('clicked menu icon')
      navbarWrapper.classList.add('show');
    })

    exitMenu.addEventListener('click', function() {
      //console.log('exit menu icon clicked')
      navbarWrapper.classList.remove('show');
    })
  }
}
</script>

<style lang="scss" scoped>
  // navigation
#mainNav {
    background: #2C3C90;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    .navbar-toggler {
        border-color: transparent;

        &:hover {
          cursor: pointer;
        }
  
        .fa-bars {
          color: #fff;
          font-size: 1rem;
        }
    }

    .navbar-wrapper {
        
        .navbar-nav {
            .nav-item .nav-link {
                color: rgba(255, 255, 255, 0.75);
                padding: 0 1rem;
                font-weight: 700;
                font-family: 'Source Sans Pro', sans-serif;
            }

            .nav-item .nav-link {
                &:hover, &:active {
                    color: rgba(255, 255, 255, 1);
                }
            }

            .router-link-exact-active {
                color: rgba(255, 255, 255, 1) !important;
            }

            .logo-wrap {
                display: none;
            }
        }
    }
}

// #mainNav.navbar-scrolled {
//     background: #f8f9fa;
//     box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);

//     .navbar-nav {
//         .nav-item .nav-link {
//             color: rgba(23, 31, 74, 0.75);
//         }

//         .nav-item .nav-link {
//             &:hover, &:active {
//                 color: rgba(23, 31, 74, 1);
//             }
//         }

//         .router-link-exact-active {
//             color: rgba(23, 31, 74, 1) !important;
//         }
//     }
// }

@media (max-width: 767px) {

    #mainNav {
        .navbar-wrapper {
            position: absolute;
            background: linear-gradient(180deg, #D8DCF3 55.28%, rgba(255, 255, 255, 0) 100%);
            width: 100%;
            top: 0;
            left: 0;
            height: 100vh;
            display: none;

            .navbar-nav {
                padding: 1rem;

                .nav-item .nav-link {
                    color: rgba(44, 60, 144, 0.75);
                    padding: 0 0 1.4rem 0;
                }

                .nav-item .nav-link {
                    &:hover, &:active {
                        color: rgba(44, 60, 144, 1);
                    }
                }
        
                .router-link-exact-active {
                    color: rgba(44, 60, 144, 1) !important;
                }

                .logo-wrap {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 2rem;
                }
            }
        }

        .navbar-wrapper.show {
            display: block;
        }

        .navbar-wrapper.hide {
            display: none;
        }
    }
}
  


</style>